/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { BtnIconAdd6 } from "../../icons/BtnIconAdd6";
import { BtnDiamondIcon } from "../BtnDiamondIcon";
import "./style.css";

export const DiamondTextIcon = ({
  label = "Text",
  orientation,
  className,
  btnDiamondIconBtnIconAdd6Color,
  textClassName,
  btnDiamondIconIcon = (
    <BtnIconAdd6
      className="btn-icon-add-6"
      color={btnDiamondIconBtnIconAdd6Color}
    />
  ),
}) => {
  return (
    <div className={`diamond-text-icon ${orientation} ${className}`}>
      <BtnDiamondIcon
        btnIconAdd6Color={btnDiamondIconBtnIconAdd6Color}
        className="btn-diamond-icon-instance"
        icon={btnDiamondIconIcon}
      />
      <div className={`text-2 ${textClassName}`}>{label}</div>
    </div>
  );
};

DiamondTextIcon.propTypes = {
  label: PropTypes.string,
  orientation: PropTypes.oneOf(["vertical", "horizontal"]),
  btnDiamondIconBtnIconAdd6Color: PropTypes.string,
};
